<template>
    <thead class="standard-service-duration-overwrite-per-shift-table-header">
        <tr class="standard-service-duration-overwrite-per-shift-table-header-row">
            <th class="standard-service-duration-overwrite-per-shift-table-header-row-cell" style="width: 40%;" scope="col">
                <span>{{ i18n("Shift") }}</span>&nbsp;<span class="mandatory">*</span>
            </th>
            <th class="standard-service-duration-overwrite-per-shift-table-header-row-cell" scope="col">
                <span>{{ i18n("Standard service duration") }}</span>&nbsp;<span class="mandatory">*</span>
            </th>
            <th class="standard-service-duration-overwrite-per-shift-table-header-row-cell" scope="col"></th>
        </tr>
    </thead>
</template>

<script setup lang="ts">
    import { i18n } from "@/portal/Trans";
</script>

<style scoped lang="scss">
    .standard-service-duration-overwrite-per-shift-table-header {
        .standard-service-duration-overwrite-per-shift-table-header-row {
            
            .standard-service-duration-overwrite-per-shift-table-header-row-cell {
                padding: 7.5px;
                
                .mandatory {
                    display: inline-block;
                    vertical-align: top;
                    font-size: 12px;
                    color: #fd397a;
                }
                
                span {
                    font-weight: 500;
                    color: #595d6e;
                }
            }
        }
    }
</style>
